module.exports = __webpack_public_path__ + "static/bestinthebusiness-33bc5c013352062bce1e26f6ad08ad9b.jpg";